/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useAuth } from "src/hooks/auth";
import { api } from "src/services/api";
import { Container, Content } from "../tax/styles";
import "./style.css";

type TransactionData = {
	id: string;
	description: string;
	serialNum: string;
	status: string;
};

// const fakeData: TransactionData[] = [
// 	{ id: "1", description: "Máquina A", serialNum: "12345", status: "Ativo" },
// 	{ id: "2", description: "Máquina B", serialNum: "67890", status: "Inativo" },
// 	{ id: "3", description: "Máquina C", serialNum: "54321", status: "Ativo" },
// 	{ id: "4", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "5", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "6", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "7", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "8", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "9", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "10", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// ];

export function MyTerminals() {
	const token = localStorage.getItem("@stricv2:token");
	const [data, setData] = useState<TransactionData[]>([]);
	const { account } = useAuth();

	const fetchMachines = async () => {
		try {
			// Substituindo a chamada à API por dados fictícios
			const { data: responseData } = await api.get(
				`/graphic/card-machines/${account.id}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);
			setData(responseData);

			// console.log("Usando dados fictícios");
			// setData(fakeData);
		} catch (error) {
			console.error("Erro ao buscar os dados:", error);
		}
	};

	useEffect(() => {
		fetchMachines();
	}, []);

	return (
		<Container className="w-full">
			<Content className="w-full h-full padding-container items-center justify-center">
				<div className="flex flex-col items-center justify-center w-full px-[2%]">
					<span className="title-text">listagem de Terminais Registrados</span>

					<div className="w-full">
						<div className="flex justify-between items-center mb-8">
							<div>
								<h3 className="title-text"  > Total de Terminais: <span className="font-bold text-[#AA7339]">{data.length}</span> </h3>

							</div>
						</div>

						<div className="flex flex-col rounded-lg bg-white w-full height-table">
							<table className="w-full border-collapse border-none">
								<thead className="bg-gray-100">
									<tr className="text-center font-semibold">
										<th className="table-title text-center align-middle  text-gray-700 bg-gray-100">
											Máquina Nome
										</th>
										<th className="table-title text-center align-middle  text-gray-700 bg-gray-100">
											Número de Série
										</th>
										<th className="table-title text-center align-middle  text-gray-700 bg-gray-100">
											Status
										</th>
									</tr>
								</thead>
							</table>
							<div className="overflow-y-auto h-full">
								<table className="w-full border-collapse border-none">
									<tbody>
										{data.map((machine) => (
											<tr
												key={machine.id}
												className="text-center font-medium h-20 border-b border-gray-200 hover:bg-gray-100"
											>
												<td className="table-text text-center align-middle  text-gray-600">
													{machine.description}
												</td>
												<td className="table-text text-center align-middle  text-gray-600">
													{machine.serialNum}
												</td>
												<td className="table-text text-center align-middle  text-gray-600">
													{machine.status}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</Content>
		</Container>
	);
}
